/* index.js */

/** External Module Dependencies **/
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import BrowserRouter from "react-router-dom/BrowserRouter";

/** Internal Module Dependencies **/
import configureStore from "./store/store";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./index.css";

ReactDOM.render(
	<Provider store={configureStore()}>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</Provider>,
	document.getElementById("root")
);

serviceWorker.unregister();
